export default {
  default: {
    overlay: "fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center",
    container: "bg-paper text-text rounded-lg shadow-lg w-[440px] sm:w-[700px] p-6 mx-4",
    titleVariant: "h3",
    titleClass: "text-text mb-4",
    divider: "border-t border-bordered mb-4",
    messageVariant: "body1_dim",
    messageClass: "mb-8",
    messageColorClass: "text-text",
    buttonRow: "flex space-x-3 mt-5",
    cancelButtonVariant: "secondary",
    confirmButtonVariant: "primary",
    buttonClass: "md:w-1/4 py-2 px-4 rounded-full",
  },

  // Admin analogue of "default"
  admin: {
    overlay: "fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center",
    container: "bg-admin_paper text-admin_text rounded-lg shadow-lg w-[440px] sm:w-[700px] p-6 mx-4",
    titleVariant: "admin_h3",
    titleClass: "text-admin_text mb-4",
    divider: "border-t border-admin_bordered mb-4",
    messageVariant: "admin_body1",
    messageClass: "mb-8",
    messageColorClass: "text-admin_text_secondary",
    buttonRow: "flex space-x-3 mt-5",
    cancelButtonVariant: "admin_secondary",
    confirmButtonVariant: "admin_primary",
    buttonClass: "md:w-1/4 py-2 px-4 rounded-full",
  },
}
